import util from '@/tools/commonUtil'
const validQuLogics = function (question, logic, quItem, toQuItem, value, anQuItemId, anValue) {
  let isShow = true
  /* const { id, allOrderById } = question */
  const { scoreQuType } = quItem
  const { chooseType, logicType, geLe, minValue, maxValue } = logic // toQuId
  if ([1, 'question'].includes(logicType)) {
    /* if (allOrderById <= toQuItem.allOrderById && toQuId !== id) { */
    isShow = commonValidLogic(chooseType, geLe, scoreQuType, value, anValue, minValue, maxValue)
    if (!isShow) {
      return isShow
    }
    /* } */
  } else if ([2, 'clientProperty'].includes(logicType)) {
    isShow = commonValidLogic(chooseType, geLe, scoreQuType, value, anValue, minValue, maxValue)
    if (!isShow) {
      return isShow
    }
  } else if (logicType === '3' || logicType === '4') {
    if (!commonValidLogic(chooseType, geLe, scoreQuType, value, anValue, minValue, maxValue)) {
      this.setLogicValue(logic, toQuItem)
    }
  }
  return isShow
}
const getQuBeforLogicsExpress = function (logic, quItem, value, anQuItemId, anValue) {
  let resultStr = ''
  const { chooseType, geLe, minValue, maxValue } = logic
  const { scoreQuType } = quItem
  resultStr = !commonValidLogic(chooseType, geLe, scoreQuType, value, anValue, minValue, maxValue)
  return resultStr
}

const commonValidLogic = (chooseType, geLe, scoreQuType, value, anValue, minValue, maxValue) => {
  let isShow = true
  if (/^1|3|5$/.test(scoreQuType)) {
    if (chooseType === '1') {
      if (util.isContainsArr(value, anValue)) {
        isShow = false
        return false
      }
    } else if (chooseType === '2') {
      if (!util.isContainsArr(value, anValue)) {
        isShow = false
        return false
      }
    } else if (geLe === '1') {
      if (util.isContainsArr(value, anValue)) {
        isShow = false
        return false
      }
    } else {
      value = Number(value[0])
      anValue = Number(anValue[0])
      if (geLe === '2') {
        if (value >= minValue && value <= maxValue) {
          isShow = false
          return false
        }
      } else if (geLe === '3') {
        if (value < anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '4') {
        if (value <= anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '5') {
        if (value > anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '6') {
        if (value >= anValue) {
          isShow = false
          return false
        }
      }
    }
  } else {
    if (geLe === '1') {
      if (util.isContainsArr(value, anValue)) {
        isShow = false
        return false
      }
    } else {
      value = Number(value[0])
      anValue = Number(anValue[0])
      if (geLe === '2') {
        if (value >= minValue && value <= maxValue) {
          isShow = false
          return false
        }
      } else if (geLe === '3') {
        if (value < anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '4') {
        if (value <= anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '5') {
        if (value > anValue) {
          isShow = false
          return false
        }
      } else if (geLe === '6') {
        if (value >= anValue) {
          isShow = false
          return false
        }
      }
    }
  }
  return isShow
}

const logic = {
  validQuLogics,
  getQuBeforLogicsExpress
}

export default logic



// WEBPACK FOOTER //
// ./src/components/editor/RateGroupBox/logic.js